<template>
    <a
        @click="redirectUser($event)"
        :class="isActive ? 'active' : ''"
        :title="theDescription"
        href="#"
        >{{ theTitle }}</a
    >
</template>

<script>
import store from '@/store';

export default {
    props: ['isActive', 'item', 'getRoutingData', 'title'],
    created: function () {
        const vm = this;
        const item = vm.item || {};
        vm.theTitle = this.title || item.title;
        vm.theDescription = item.description || vm.theTitle;
    },
    data: function () {
        return {
            theTitle: '',
            theDescription: ''
        };
    },
    methods: {
        redirectUser(e) {
            const vm = this;
            const item = vm.item;
            if (e) e.preventDefault();
            store.dispatch('display/clearMessages');

            const params = {
                // userID: user.userID,
                routingData: vm.getRoutingData ? vm.getRoutingData() : {}
            };

            if (item.isExternal) window.open(item.url);
            else {
                //We will get an error if get redirect to the same route
                if (vm.$route.name !== item.name)
                    vm.$router.push({
                        url: item.url,
                        name: item.name,
                        params
                    });
                // .catch((err) => {
                //     vm.emitter.emit('redirectedToCurrentPage', {});
                // });
            }
            return false;
        }
    }
};
</script>
